@let group = groupSg();
@let messages = messagesSg();
@let isSubmitting = isSubmittingSg();
@let error = errorSg();

@let presentConversation = presentConversationSg();
@let conversations = currentAgentConversationsSg();
@let fullscreenAssistantSections = fullscreenAssistantSectionsSg();
@let selectedConversationId = selectedConversationIdSg();
@let selectedAssistantDisplay = assistants.selectedAssistantDisplaySg();
@let fullScreen = fullScreenSg();

<ng-template
  #conversationList
  let-closeOnSelect="closeOnSelect"
>
  <div class="atn-assistant-conversational__conversation-list">
    @if (!selectedConversationId) {
      <button
        class="atn-assistant-conversational__conversation-item atn-assistant-conversational__conversation-item--new"
        type="button"
        (click)="selectNewConversation(closeOnSelect)"
      >
        <i class="atn-icon atn-plus atn-blue"></i>
        <span class="atn-assistant-conversational__conversation-item-name"
          >New conversation</span
        >
      </button>
    }
    @for (conversation of conversations; track conversation.id) {
      <button
        class="atn-assistant-conversational__conversation-item"
        [class.atn-assistant-conversational__conversation-item--active]="
          conversation.id === selectedConversationId
        "
        (click)="selectConversationFromHistory(conversation.id, closeOnSelect)"
        type="button"
      >
        <span class="atn-assistant-conversational__conversation-item-name">{{
          conversation.name
        }}</span>
        <div
          class="atn-assistant-conversational__conversation-item-actions"
          (click)="$event.stopPropagation()"
        >
          <i
            class="atn-icon atn-edit atn-assistant-conversational__conversation-item-edit atn-blue"
            title="Edit conversation"
            (click)="editConversation(conversation.id, $event)"
          ></i>
          <i
            class="atn-icon atn-trash atn-assistant-conversational__conversation-item-delete atn-red"
            title="Delete conversation"
            (click)="deleteConversation(conversation.id, $event)"
          ></i>
        </div>
      </button>
    } @empty {
      <div class="atn-assistant-conversational__conversation-list-empty">
        <i class="atn-icon atn-history"></i>
        <p>No conversations yet</p>
      </div>
    }
  </div>
</ng-template>

<ng-template #chatPanel>
  <div
    class="atn-assistant-conversational__messages"
    #messagesContainer
  >
    @let showLoader = showLoaderSg();

    @if (showLoader) {
      <atn-assistant-loader />
    } @else {
      <!-- Messages -->
      @for (message of messages; track message.id) {
        <atn-assistant-message
          class="atn-assistant-conversational__message"
          [message]="message"
          (fileDownload)="fileDownloadClickHandler($event)"
        />
      } @empty {
        @if (error) {
        } @else {
          <atn-assistant-empty-state />
        }
      }
    }
  </div>

  <!-- Message input  -->
  <atn-assistant-message-input
    class="atn-assistant-conversational__message-input"
    [allowFileAttachments]="true"
    [assistants]="fullScreen ? [] : assistants.availableAssistantDisplaysSg()"
    [(content)]="questionSg"
    [disabled]="isSubmitting"
    [externalKnowledgeBaseRetrievalRecords]="
      assistants.activeSessionKnowledgeBaseRetrievalRecordsSg()
    "
    [selectedAgentId]="assistants.selectedAgentIdSg()"
    (selectedAgentIdChange)="assistants.selectAgent($event)"
    (submit)="submitMessage($event)"
  />
</ng-template>

<div
  class="atn-assistant-conversational"
  [class.atn-assistant-conversational--fullscreen]="fullScreen"
>
  @if (fullScreen) {
    <aside class="atn-assistant-conversational__history">
      <div class="atn-assistant-conversational__assistant-list">
        @for (
          section of fullscreenAssistantSections;
          track section.assistant.id
        ) {
          <div class="atn-assistant-conversational__assistant-section">
            <button
              class="atn-assistant-conversational__assistant-section-header"
              type="button"
              [title]="section.assistant.name"
              (click)="toggleAssistantSection(section.assistant.id)"
            >
              <span
                class="atn-assistant-conversational__assistant-section-name"
                >{{ section.assistant.name }}</span
              >
              <i
                class="atn-icon atn-blue"
                [class.atn-angle-down]="section.expanded"
                [class.atn-angle-right]="!section.expanded"
              ></i>
            </button>
            @if (section.expanded) {
              <div
                class="atn-assistant-conversational__assistant-section-conversations"
              >
                <button
                  class="atn-assistant-conversational__conversation-item atn-assistant-conversational__conversation-item--new"
                  type="button"
                  (click)="
                    selectNewConversationForAgent(
                      section.assistant.id,
                      false
                    )
                  "
                >
                  <i class="atn-icon atn-plus atn-blue"></i>
                  <span
                    class="atn-assistant-conversational__conversation-item-name"
                    >New conversation</span
                  >
                </button>
                @for (
                  conversation of section.conversations;
                  track conversation.id
                ) {
                  <button
                    class="atn-assistant-conversational__conversation-item"
                    [class.atn-assistant-conversational__conversation-item--active]="
                      conversation.id === selectedConversationId
                    "
                    (click)="
                      selectAgentConversationFromHistory(
                        section.assistant.id,
                        conversation.id,
                        false
                      )
                    "
                    type="button"
                  >
                    <span
                      class="atn-assistant-conversational__conversation-item-name"
                      >{{ conversation.name }}</span
                    >
                    <div
                      class="atn-assistant-conversational__conversation-item-actions"
                      (click)="$event.stopPropagation()"
                    >
                      <i
                        class="atn-icon atn-edit atn-assistant-conversational__conversation-item-edit atn-blue"
                        title="Edit conversation"
                        (click)="
                          editAgentConversation(
                            section.assistant.id,
                            conversation.id,
                            $event
                          )
                        "
                      ></i>
                      <i
                        class="atn-icon atn-trash atn-assistant-conversational__conversation-item-delete atn-red"
                        title="Delete conversation"
                        (click)="
                          deleteAgentConversation(
                            section.assistant.id,
                            conversation.id,
                            $event
                          )
                        "
                      ></i>
                    </div>
                  </button>
                }
              </div>
            }
          </div>
        } @empty {
          <div class="atn-assistant-conversational__conversation-list-empty">
            <i class="atn-icon atn-history"></i>
            <p>No conversations yet</p>
          </div>
        }
      </div>
    </aside>
    <div class="atn-assistant-conversational__chat">
      <div class="atn-assistant-conversational__chat-header">
        <span class="atn-assistant-conversational__chat-title">{{
          selectedAssistantDisplay?.name ?? 'Assistant'
        }}</span>
      </div>
      <ng-container *ngTemplateOutlet="chatPanel"></ng-container>
    </div>
  } @else {
    <!-- Top Bar -->
    <div class="atn-assistant-conversational__topbar">
      <button
        class="atn-assistant-conversational__topbar-toggle"
        type="button"
        [title]="presentConversation ? 'Back to chat' : 'Conversation history'"
        (click)="presentConversationSg.set(!presentConversation)"
      >
        <i
          class="atn-icon atn-blue"
          [class.atn-history]="!presentConversation"
          [class.atn-angle-left]="presentConversation"
        ></i>
      </button>
      @if (presentConversation) {
        <span class="atn-assistant-conversational__topbar-title">History</span>
        <button
          class="atn-assistant-conversational__topbar-new-chat"
          type="button"
          title="New conversation"
          (click)="selectConversation(undefined)"
        >
          <i class="atn-icon atn-plus atn-blue"></i>
        </button>
      } @else {
        <span class="atn-assistant-conversational__topbar-title">{{
          selectedAssistantDisplay?.name ?? 'Assistant'
        }}</span>
      }
    </div>

    @if (presentConversation) {
      <ng-container
        *ngTemplateOutlet="conversationList; context: { closeOnSelect: true }"
      ></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="chatPanel"></ng-container>
    }
  }
</div>

@if (
  group.conversation.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal()
) {
  @let conversationToDelete =
    group.conversation.plugins.editingPlugin.feature.selectors
      .deletedEntities()
      .asSignal()[0];
  @let isSubmitting =
    group.conversation.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();
  <atn-ds-confirmation-overlay
    title="Delete Conversation"
    [description]="
      'Are you sure you want to delete <b>' +
      conversationToDelete.name +
      '</b>? This action cannot be undone.'
    "
    [validation]="conversationToDelete.name"
    [loading]="isSubmitting"
    (cancel)="cancelDeleteConversation()"
    (confirm)="confirmDeleteConversation()"
    confirmButtonText="Delete"
  />
}

@let conversationToEdit =
  group.conversation.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal();
@if (conversationToEdit) {
  @let isSubmitting =
    group.conversation.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();
  <atn-ds-centered-overlay>
    <atn-ds-widget title="Update Conversation">
      <i
        actions
        class="atn-icon atn-close atn-red"
        (click)="cancelEditConversation()"
      ></i>
      <div class="atn-assistant-conversational__edit-dialog-content">
        <atn-ds-text
          label="Name"
          placeholder="Enter conversation name"
          [value]="conversationToEdit.name"
          (change)="updateConversationName($event ?? '')"
        ></atn-ds-text>
      </div>
      <div
        footer
        class="atn-assistant-conversational__edit-dialog-footer"
      >
        <atn-ds-button
          type="transparent"
          [disabled]="isSubmitting"
          (click)="cancelEditConversation()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button
          [loading]="isSubmitting"
          (click)="saveConversation()"
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
